// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F8GS","type":"styles_type__eRw0D","choices":"styles_choices__2o7WB"};